import * as R from "./reducers";

import { SharedActions } from "../flux/actions/sharedActions";

// TODO refactor this to initialise and cache this in local storage using LocalStorageReducer methods
const userReducer = R.chain<IState<IUser>>(
  R.when(SharedActions.Authentication.Logout, R.clear(R.Auth.clearState)),

  R.fromApi<IApiResponse<IUser>, IUser>(SharedActions.User.RefreshProfile, x => x.data),

  R.fromPayload<ILoginResponse, IUser>(SharedActions.Authentication.Login, x => x.user, (newState, payload) => {
    if (newState.status === "OK" && !(payload instanceof Error)) {
      R.Auth.saveState(newState.data, { token: payload.token, expires: payload.expires, context: newState.context });
    }
  }),
);

export default userReducer;
